import requestStatuses from '@cinch/oxd-utils/request-status/src'
import { get as storageGet, StorageKeys } from '@cinch/oxd-utils/storage/src'
import * as types from '../types'

export interface Passengers {
  age: number
  height: number
  size?: number
  type: number
}

export interface LifestyleData {
  roadCity: number
  roadCountry: number
  roadMotorway: number
  distanceLong: number
  distanceMedium: number
  distanceShort: number
  passengers: Passengers[]
  [key: string]: any
}

export interface LifestyleDomainReducer {
  status: string
  data: LifestyleData
}

export const initialState: LifestyleDomainReducer = {
  status: requestStatuses.INITIAL,
  data: {
    passengers: [{ type: 0, age: 0, height: 1 }],
    roadCity: 2,
    roadCountry: 2,
    roadMotorway: 2,
    distanceLong: 2,
    distanceMedium: 2,
    distanceShort: 2,
    drivingFrequency: 1,
    ...storageGet(StorageKeys.lifestyle),
  },
}

export default (state = initialState, action: any): LifestyleDomainReducer => {
  switch (action.type) {
    case types.LIFESTYLE_UPDATE_REQUEST:
      return { ...state, status: requestStatuses.PENDING }
    case types.GET_LIFESTYLE_SUCCESS:
      return { ...state, data: action.payload }
    case types.LIFESTYLE_UPDATE_SUCCESS:
      return { ...state, status: requestStatuses.SUCCESS, data: action.payload }
    case types.LIFESTYLE_UPDATE_FAILURE:
      return { ...state, status: requestStatuses.ERROR }
    case types.UPDATE_ANON_LIFESTYLE:
      return { ...state, data: action.payload.data }
    default:
      return { ...state }
  }
}
